module.exports = __webpack_public_path__ + "static/eco-drive-dashboard-c9fc32ddfd69ca31e4ceb9e98030a978.svg";